import styled from '@emotion/styled';
import { FooterLinkList } from './FooterLinkList';
import { IFooterLinkSection } from './types';
import { Css, Responsive } from '../../../ui';

export function FooterLinkSection({ links, title }: IFooterLinkSection) {
	return (
		<StyledGridItem>
			<StyledTitle>{title}</StyledTitle>
			<FooterLinkList links={links} />
		</StyledGridItem>
	);
}

const StyledTitle = styled.h5`
	margin-bottom: ${Css.pxToRem(16)};
`;

const StyledGridItem = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;

	min-width: ${Css.pxToRem(148)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		max-width: fit-content;
	}
`;
